"use client";

import React from "react";

// The animations (and their CSS) live in their own chunks and are only fetched once a peek is actually due,
// so they do not add to the initial load of the funnel.
const CatPeek = React.lazy(() => import("./CatPeek"));
const DogPeek = React.lazy(() => import("./DogPeek"));

interface PetPeekProps {
  species: "cat" | "dog" | null;
  /** Horizontal centre of the animal as a percentage of the table width. */
  leftPercent: number;
  /** Called once the animal has ducked away again, so the parent can allow a replay. */
  onDone: () => void;
}

/** Picks the animal for the customer's pet and loads it on demand. Renders nothing while loading. */
const PetPeek: React.FC<PetPeekProps> = ({ species, leftPercent, onDone }) => (
  <React.Suspense fallback={null}>
    {species === "dog" ? <DogPeek leftPercent={leftPercent} onDone={onDone} /> : <CatPeek leftPercent={leftPercent} onDone={onDone} />}
  </React.Suspense>
);

export default PetPeek;
